<template>
  <div class="kefuList">
    <div class="info-content">
      <div class="v-text" v-html="htmlData"></div>
    </div>
  </div>
</template>
<script>
import kefuLanguage from "./kefuLanguage.js";

export default {
  name: "kefuList",
  data() {
    return {
      language: localStorage.getItem("requestLanguage") || "unknown",
      userData: null,
      htmlData: null,
      htmlInput: null,
      isTyping: false,
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
    };
  },
  mounted() {
    this.getOptions().then((success) => {
      if (success) {
        this.setButtonEvent();
        this.handleLanguage();
        this.handleFocus();
      }
    });
  },
  methods: {
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getCustomerPersonalInfo(), this.cozeChatPage()]).then(
          (success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          }
        ).catch(() => {
          this.$commonMethod.hideLoading();
        })
      });
    },
    getCustomerPersonalInfo() {
      return new Promise((resolve, reject) => {
        var param = {};
        this.$api.user
          .getCustomerPersonalInfo(param)
          .then((res) => {
            this.userData = res.data;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    setButtonEvent() {
      var action = () => {
        this.htmlInput = document.getElementsByClassName("chat-input")[0].children[0];
        if (this.htmlInput && this.htmlInput.value) {
          if (!this.isTyping) {
            this.applyMessage(this.htmlInput.value, "user");
            this.cozeChat(this.htmlInput.value);
          }
        }
      };
      document.getElementById("input").addEventListener("keyup", (event) => {
        if (event.key === "Enter") {
          action();
        }
      });
      document.getElementById("sendBtn").addEventListener("click", (event) => {
        action();
      });
    },
    cozeChatPage() {
      return new Promise((resolve, reject) => {
        this.$api.home
          .cozeChatPage({})
          .then((res) => {
            this.htmlData = res.data;
            resolve(true);
          })
          .catch((err) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: err.message,
            });
            reject();
          });
      });
    },
    cozeChat(message) {
      var param = {
        SystemSource: 3,
        message: message,
        customer_id: this.userData.CustomerNumber,
        customer_name: this.userData.CompanyName,
        language: this.language,
      };
      this.handleTyping(true);
      this.$api.home
        .cozeChat(param)
        .then((res) => {
          this.htmlInput.value = "";
          var data = JSON.parse(res.data);
          var reply = data.reply;
          this.applyMessage(reply, "agent");
          this.handleTyping(false);
        })
        .catch((err) => {
          this.handleTyping(false);
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: err.message,
            type: "danger",
          });
        });
    },
    applyMessage(text, type) {
      var messages = document.getElementsByClassName("chat-messages")[0];

      const outerDiv = document.createElement("div");
      outerDiv.className = "message " + type;

      const innerDiv = document.createElement("div");
      innerDiv.className = "bubble";
      innerDiv.textContent = text;

      outerDiv.appendChild(innerDiv);
      messages.appendChild(outerDiv);
    },
    onClickLeft() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
    },
    handleTyping(isShow) {
      if (isShow) {
        this.isTyping = true;
        document.getElementById("input").disabled = true;
        var messages = document.getElementsByClassName("chat-messages")[0];

        var outerDiv = document.createElement("div");
        outerDiv.className = "typing-indicator";
        outerDiv.id = "typing";
        outerDiv.style.display = "block";

        var innerDiv1 = document.createElement("span");
        var innerDiv2 = document.createElement("span");
        var innerDiv3 = document.createElement("span");
        outerDiv.appendChild(innerDiv1);
        outerDiv.appendChild(innerDiv2);
        outerDiv.appendChild(innerDiv3);
        messages.appendChild(outerDiv);
      } else {
        this.isTyping = false;
        document.getElementById("input").disabled = false;
        var typings = document.getElementsByClassName("typing-indicator");
        if (typings && typings.length > 0) {
          for (var type of typings) {
            type.style.display = "none";
          }
        }
      }
    },
    handleFocus() {
      const meta = document.querySelector('meta[name="viewport"]');
      if (meta) {
        meta.content =
          "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
      }
    },
    handleLanguage() {
      var t = kefuLanguage[this.language];
      document.querySelector(".chat-header .info h3").textContent = t.title;
      document.querySelector(".chat-header .info p").innerHTML =
        '<span class="status-dot"></span>' + t.status;
      document.querySelector(".message.agent .bubble").textContent = t.welcome;
      document.getElementById("input").placeholder = t.inputPlaceholder;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";

.kefuList {
  .info-content {
    position: absolute;
    left: 0;
    top: 50px;
    width: 100%;
    min-height: 120vh;
    background: #f8f9fa;

    .v-text {
      ::v-deep .chat-container {
        height: auto !important;
        box-shadow: unset !important;
        background: transparent;
        margin: auto;

        .chat-messages {
          margin-bottom: 77px;
          overflow-y: hidden;
          background: transparent;
        }

        .chat-input {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
        }
      }
    }
  }
}
</style>
